module.exports = __webpack_public_path__ + "img/ebcTh.9d3af6a2.svg";